// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Data Management',
  subtitle: 'Export and manage data',
  exportCustomers: 'Export Customers',
  exportDomains: 'Export Domains',
  exportPayments: 'Export Payments',
  exportSuccess: 'Data successfully exported',
  exportError: 'Export operation failed',
  importData: 'Import Data',
  importSuccess: 'Data successfully imported',
  importError: 'Import operation failed',
  dataOperations: 'Data Operations',
  dataExport: 'Data Export',
  dataImport: 'Data Import',
  exportAll: 'Export All Data',
  exportAllDesc: 'Export all tables to a single JSON file',
  exportAllButton: 'Export All',
  exportSelected: 'Export Selected',
  exportSelectedDesc: 'Export only selected tables',
  exportSelectedButton: 'Export Selected',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  selectAtLeastOne: 'Please select at least one table',
  exportLoading: 'Exporting data...',
  exportSelectedLoading: 'Exporting selected tables...',
  exportSuccessCount: 'records exported',
  unknownError: 'Unknown error',
  warning: 'Warning',
  warningDesc: 'Import operations may overwrite existing data. Please backup before importing.',
  selectJsonFile: 'Select JSON File',
  selectedFile: 'Selected file',
  fileSize: 'KB',
  importOptions: 'Import Options',
  clearExisting: 'Clear existing data before import',
  clearExistingDesc: 'Delete all existing records before importing new data',
  skipDuplicates: 'Skip duplicate records',
  skipDuplicatesDesc: 'Do not import records that already exist',
  updateExisting: 'Update existing records',
  updateExistingDesc: 'Update existing records with matching data',
  validateFile: 'Validate File',
  importButton: 'Import Data',
  importing: 'Importing...',
  fileValid: 'File is valid',
  fileHasErrors: 'File has errors',
  valid: 'valid',
  preparing: 'Preparing...',
  table: 'tables',
  recordsProcessed: 'records processed',
  percent: '%',
  tables: {
    companies: 'Companies',
    companiesDesc: 'Company information',
    registrars: 'Registrars',
    registrarsDesc: 'Domain registrars',
    servers: 'Servers',
    serversDesc: 'Server information',
    accounts: 'Accounts (Wallet)',
    accountsDesc: 'Money accounts and balances',
    languages: 'Languages',
    languagesDesc: 'System languages',
    users: 'Users',
    usersDesc: 'System users',
    domainPrices: 'Domain Prices',
    domainPricesDesc: 'Domain price definitions',
    hostingPrices: 'Hosting Prices',
    hostingPricesDesc: 'Hosting price definitions',
    settings: 'Settings',
    settingsDesc: 'System settings',
    customers: 'Customers',
    customersDesc: 'Customer information',
    domains: 'Domains',
    domainsDesc: 'Domain information',
    companyPayments: 'Company Payments',
    companyPaymentsDesc: 'Payment records',
    payments: 'Payments',
    paymentsDesc: 'General payment records',
    accountTransactions: 'Account Transactions',
    accountTransactionsDesc: 'Wallet transactions and transfers',
    translations: 'Translations',
    translationsDesc: 'Language translations',
    mobileAccessKeys: 'Mobile Access Keys',
    mobileAccessKeysDesc: 'Mobile app access keys'
  },
  importErrorMessage: 'import error',
  importAdded: 'added',
  importUpdated: 'updated',
  importSkipped: 'skipped',
  importCompleted: 'Import completed successfully',
  importLoading: 'Importing data...',
  selectFileFirst: 'Please select a file first',
  validatingFile: 'Validating file...',
  validationSuccess: 'File validated successfully',
  validationError: 'Validation failed',
  selectValidJson: 'Please select a valid JSON file',
  exporting: 'Exporting...'
};
